import { CommandResult } from '@amdb/drone/shared/models';
import { SysConfig, SysConfigToFlyAuthoritySection, SysConfigZoneSection } from '@amdb/drone/shared/models/sys-config.model';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class SysConfigService {
    constructor(private http: HttpClient) {}

    getSysConfig(): Promise<CommandResult<SysConfig>> {
        return lastValueFrom(this.http.get<CommandResult<SysConfig>>('/api/v1/admin/sys-config'));
    }

    updateSysConfig(sysConfig: SysConfig): Promise<CommandResult<void>> {
        return lastValueFrom(this.http.patch<CommandResult<void>>('/api/v1/admin/sys-config', sysConfig));
    }

    getZoneSection(): Promise<CommandResult<SysConfigZoneSection>> {
        return lastValueFrom(this.http.get<CommandResult<SysConfigZoneSection>>('/api/v1/admin/sys-config/zone'));
    }

    getToFlyAuthoritySection(): Promise<CommandResult<SysConfigToFlyAuthoritySection>> {
        return lastValueFrom(this.http.get<CommandResult<SysConfigToFlyAuthoritySection>>('/api/v1/admin/sys-config/to-fly-authority'));
    }
}
